import { render, staticRenderFns } from "./Paymentmethods.vue?vue&type=template&id=20e17636&lang=pug&"
import script from "./Paymentmethods.vue?vue&type=script&lang=ts&"
export * from "./Paymentmethods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports